<template>
  <div class="card "
       :style="`width:${width};height:${height}`">
    <div class="background"></div>
    <div class="top-triangle"></div>
    <div class="bottom-triangle"></div>
    <div class="head"
         :style="`font-size:${12*$store.state.ratio.hole}px`">
      {{name}}
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  props: ["width", 'height', 'name'],
  data () {
    return {
      headHeight: ''
    }
  },
  mounted () {
    this.headHeight = parseFloat(this.height) / 10 * this.$store.state.ratio.hole + 'px'
  }
}
</script>
<style lang='scss' scoped>
.card {
  position: relative;
  display: inline-block;
  border: 1px rgb(58, 98, 203) solid;
  // .background {
  //   // background: url("../../../../static/img/bg-block.png") repeat;
  //   background-size: 14px;
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   top: 0px;
  //   left: 0px;
  //   opacity: 0.85;
  //   z-index: -1;
  // }
  // .top-triangle::before {
  //   display: inline-block;
  //   content: "";
  //   width: 16px;
  //   height: 16px;
  //   border-left: 2px solid #b6e2ff;
  //   border-top: 2px solid #b6e2ff;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
  // .top-triangle::after {
  //   display: inline-block;
  //   content: "";
  //   width: 16px;
  //   height: 16px;
  //   border-right: 2px solid #b6e2ff;
  //   border-top: 2px solid #b6e2ff;
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  // }
  // .bottom-triangle::before {
  //   display: inline-block;
  //   content: "";
  //   width: 16px;
  //   height: 16px;
  //   border-left: 2px solid #b6e2ff;
  //   border-bottom: 2px solid #b6e2ff;
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  // }
  // .bottom-triangle::after {
  //   display: inline-block;
  //   content: "";
  //   width: 16px;
  //   height: 16px;
  //   border-right: 2px solid #b6e2ff;
  //   border-bottom: 2px solid #b6e2ff;
  //   position: absolute;
  //   bottom: 0;
  //   right: 0;
  // }
  .head {
    background: rgb(35, 70, 162);
    width: 100%;
    text-align: center;
    position: relative;
  }
}
</style>